import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';

export const timeSlotsApi = createApi({
    reducerPath: 'timeSlotsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_ROUTE}/pos`,
        prepareHeaders: (headers, { getState }) => {
            const token = getState()?.posData?.token;
            if (token) {
                headers.set('Authorization', token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getTimeSlots: builder.query({
            query: ({ page, limit, search }) => {
                return {
                    url: `/time-slots`,
                    method: 'GET',
                    params: {
                        page: page,
                        perPage: limit,
                        search: search ?? ""
                    },
                }
            },
            providesTags: ['time-slots'],
            // transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        addAutomateTimeSlots: builder.mutation({
            query: (body) => ({
                url: '/time-slots/automate',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['time-slots'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        addTimeSlots: builder.mutation({
            query: (body) => ({
                url: '/time-slots',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['time-slots'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        updateTimeSlots: builder.mutation({
            query: ({ id, ...body }) => ({
                url: `/time-slots/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['time-slots'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        deleteTimesSlots: builder.mutation({
            query: (id) => ({
                url: `/time-slots/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['time-slots'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        changeTimeSlotStatus: builder.mutation({
            query: ({ id, body }) => ({
                url: `/time-slots/change-status/${id}`,
                method: 'PUT',
                body: { status: body },
            }),
            invalidatesTags: ['time-slots'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),


        //  TimeSlots Category
        getTimeSlotsCategory: builder.query({
            query: () => {
                return {
                    url: `/time-slots/category?parPage=all`,
                    method: 'GET',
                }
            },
            providesTags: ['timeCategory'],
            // transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        addTimeSlotsCategory: builder.mutation({
            query: (body) => ({
                url: '/time-slots/category',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['timeCategory'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        updateTimeSlotsCategory: builder.mutation({
            query: ({ id, ...body }) => ({
                url: `/time-slots/category/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['timeCategory'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        deleteTimesSlotsCategory: builder.mutation({
            query: (id) => ({
                url: `/time-slots/category/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['timeCategory'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        getTableTimeSlots: builder.query({
            query: ({ is_weekend, table_id, booking_date, timezone_offset }) => {
                let url = `/time-slots/table-slots?is_weekend=${is_weekend}`;
                if (table_id) url += `&table_id=${table_id}`;
                if (booking_date) url += `&booking_date=${booking_date}`;
                if (timezone_offset) url += `&timezone_offset=${timezone_offset}`;
                return {
                    url,
                    method: "GET",
                };
            },
            providesTags: ["time-slots"],
            transformErrorResponse: (error) => transformResponseHandler(error),
        }),
    }),
});

export const {
    useGetTimeSlotsQuery,
    useAddTimeSlotsMutation,
    useAddAutomateTimeSlotsMutation,
    useUpdateTimeSlotsMutation,
    useDeleteTimesSlotsMutation,
    useChangeTimeSlotStatusMutation,

    useGetTimeSlotsCategoryQuery,
    useAddTimeSlotsCategoryMutation,
    useUpdateTimeSlotsCategoryMutation,
    useDeleteTimesSlotsCategoryMutation,
    useGetTableTimeSlotsQuery
} = timeSlotsApi;
